import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\GetPaymentByFactureIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByFactureIdController.php
* @route '/api/invoicing/{invoice}/payment'
*/
const GetPaymentByFactureIdController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByFactureIdController.url(args, options),
    method: 'get',
})

GetPaymentByFactureIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/payment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Payment\GetPaymentByFactureIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByFactureIdController.php
* @route '/api/invoicing/{invoice}/payment'
*/
GetPaymentByFactureIdController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetPaymentByFactureIdController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\GetPaymentByFactureIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByFactureIdController.php
* @route '/api/invoicing/{invoice}/payment'
*/
GetPaymentByFactureIdController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByFactureIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Payment\GetPaymentByFactureIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByFactureIdController.php
* @route '/api/invoicing/{invoice}/payment'
*/
GetPaymentByFactureIdController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentByFactureIdController.url(args, options),
    method: 'head',
})

export default GetPaymentByFactureIdController